module.exports = "//docs.gtimg.com/slide/img/framework/frame-pc/components/play-menu-item/img/titlebar-slide-show-preview-ac135c.svg";